import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import {
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../_services';
import { LOCAL_RECOVERABLE_ERRORS } from './local-response-error.context';

@Injectable()
export class GlobalResponseInterceptorInterceptor implements HttpInterceptor {

  constructor(
    private router:Router,
    private authService: AuthService
  ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      let currentRoute = window.location.pathname;
      var res = next.handle(request);
      let apiUrl = request.url;
      let apiMethod = request.method;
      
      return res.pipe(
        catchError((error: HttpErrorResponse) => {
          if (request.context.get(LOCAL_RECOVERABLE_ERRORS) && (error.status === 0 || error.status >= 500)) {
            return throwError(error);
          }
          let isHandled = this.handleError(error, currentRoute, apiUrl, apiMethod); // Handle navigation based on error status
          // RxJS 6: throwError takes the error value directly (the () => error factory
          // syntax is RxJS 7+ and would emit the function itself instead of the error)
          return isHandled ? EMPTY : throwError(error); 
        })
      );
    }
  
    private handleError(error: HttpErrorResponse, currentRoute: string, apiUrl:string, requestMethod:string): boolean {
      // A backend branch without deployment metadata must not interrupt the application.
      if (apiUrl === '/api/v1/demo-deployment') return false;
      // AuthService always clears the local session, including when logout fails.
      if (apiUrl.includes('/v1/auth/logout')) return false;
      // error message on 403      
      // console.log("handleError : ", error.error.message);

      // Public fiche d'appel d'offres: an anonymous page that renders its own
      // inline states. Every global redirect below (logout, /access-denied,
      // /**, /server-error) would eject the visitor off the fiche and hide the
      // reason, so let these errors reach the component untouched.
      if (apiUrl.includes("/v1/public/consultation/")) return false;
      // Keep deposit failures on the company page so the file can be selected again.
      if (/\/ce-project-invites\/[^/]+\/quote-documents(?:\/|$|\?)/.test(apiUrl) && error.status !== 401 && error.status !== 451) return false;
      // A missing or unreadable preview stays in its dialog; access restrictions still apply.
      if (/\/ce-project-invites\/[^/]+\/complementary-documents\/preview(?:$|\?)/.test(apiUrl)
        && ![401, 403, 451].includes(error.status)) return false;
      // 'Dépôt après la date limite : Non autorisé': the page shows the server message.
      if (error.status === 403 && error?.error?.err?.code === 'LATE_SUBMISSION_FORBIDDEN') return false;
      // Company pricing refused (consultation not accepted, lot declined or attributed): the page stays open.
      if (error.status === 403 && ['INVITE_NOT_ACCEPTED', 'LOT_DECLINED', 'LOT_ATTRIBUTED'].includes(error?.error?.err?.code)) return false;
      // Planning renders save failures inline so task drafts and undo state survive.
      if (/\/ce-projects\/[^/]+\/plannings(?:\/|$|\?)/.test(apiUrl) && error.status !== 401 && error.status !== 451) return false;

      // when an error occurs on suggestions api don't go to errors page, just throw error on console
      let isSuggestionsAPI = apiUrl.includes("/cstb-suggestions") && requestMethod == "POST";      
      const errorMessage = typeof error.error === 'string' ? error.error : error?.error?.message;

      if (error?.status === 451) {
        let userSessionLocation = {
          country: error.error["country"],
          city: error.error["city"],
        };
        localStorage.setItem("userSessionLocation", JSON.stringify(userSessionLocation));
        this.router.navigate(["/no-multi-users"], { replaceUrl: true });
        return true;
      // } else if (error.status === 500 && !isSuggestionsAPI && (error.error.err||{}).message!="You already reached maximum users" && !error?.error?.includes('Only PNG, JPEG, and JPG files')) {
      } else if(error?.status === 500 && !isSuggestionsAPI && (error?.error?.err||{}).message!="You already reached maximum users" && !errorMessage?.includes('Only PNG, JPEG, and JPG files')) {
        this.router.navigate(['/server-error'], { queryParams: { returnURL: currentRoute } });
        return true;
      } else if (error?.status === 502) {
        this.router.navigate(['/server-inaccessible'], { queryParams: { returnURL: currentRoute } });
        return true;
      } 
      //  else if (error.status === 403 && error?.error?.err?.message != 'login failed' && error?.error?.err?.message != "Only demo" && error?.error?.message!='User Not authorized to use cstb' && !error?.error?.err?.message.includes('You dont have the rights to view')) { 
      // wrong / expired code: let the 403 reach the component so it can show the
      // error inline (MFA step, artisan email-code step) instead of redirecting
      else if (error.status === 403 && (apiUrl.includes('/auth/mfa/verify') || apiUrl.includes('/auth/artisan-email-code/verify'))) {
        return false;
      }
      // signup refused by the invisible reCAPTCHA: the form shows the v2 checkbox inline
      else if (error.status === 403 && error?.error?.err?.captchaRequired === true) {
        return false;
      }
      else if (error.status === 403 && error?.error?.err?.message != 'login failed' && error?.error?.message != "Only demo" && error?.error?.message!='User Not authorized to use cstb' && !error?.error?.err?.message.includes('You dont have the rights to view')) { 
        this.router.navigate(['/access-denied'], { queryParams: { returnURL: '/' } });
        return true;
      } else if (error?.status === 404 && !apiUrl.includes("assets/version.json") && currentRoute!='/artisan/subscribe'  && error?.error?.err?.message!='Lot has not been found') {
        this.router.navigate(['/**'], { queryParams: { returnURL: '/' } });
        return true;
      } 
      // else if (error.status === 413) {
      //   this.router.navigate(['/entity-too-large'], { queryParams: { returnURL: currentRoute } });
      //   return true;
      // }
      else if(error?.status == 401 && !apiUrl.includes("/v1/auth/logout") && !currentRoute.includes("/artisan/dpgf/")){
        this.authService.logout()
        return true;
      }
      return false;
    }
 
}
